export const COMPANY_NAME = 'Naxos.ai';
